<template>
  <div class="box" style="display: flex;flex-wrap: wrap">
    <div>
      <span>风速</span>
      <span>{{monitor.a077}}m/s</span>
    </div>
    <div>
      <span>风向</span>
      <span>{{monitor.a078}}</span>
    </div>
    <div>
      <span>空气温度</span>
      <span>{{monitor.a040}}℃</span>
    </div>
    <div>
      <span>空气湿度</span>
      <span>{{monitor.a041}}%RH</span>
    </div>
    <div>
      <span> 光照强度</span>
      <span>{{monitor.a042}}Lux</span>
    </div>
    <div>
      <span>二氧化碳</span>
      <span>{{monitor.a043}}ppm</span>
    </div>
    <div>
      <span>大气压强</span>
      <span>{{monitor.a044}}kpa</span>
    </div>
    <div>
      <span>雨量</span>
      <span>{{monitor.a058}}mm</span>
    </div>
  </div>
</template>
<script>
  import { monitorData } from '@/api/demo.js'
  export default {
    name: 'metro',
    props: {
      sn:{
        type:String,
        required:false
      }
    },
    data() {
      return {
        monitor:{}
      }
    },
    mounted() {
      this.monitorDataGet()
      let time=null
      time=setInterval(()=>{
        this.monitorDataGet()
      },60000)
      console.log(this.phase)
    },
    methods: {
      monitorDataGet() {
        monitorData(this.sn).then(data=>{
          this.monitor=data
          console.log(data)
        })
      }
    }
  }
</script>
<style scoped>
  .box > div{
    margin-right:10px ;
  }
</style>



// WEBPACK FOOTER //
// src/components/monitor/MonitorDemo/Meteo.vue